import { patchRequest } from '@/core';
import { maintenance } from '@/requests';

export default async function updateDeviationTypeRequest(id, patch) {
	let url = maintenance.getDeviationTypesByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}